import { Injectable } from '@angular/core';
import { Handelsgeschaeft, HandelsgeschaeftTyp, RefiZinssatz, Zinssatz } from 'lion-api';
import RichtungEnum = HandelsgeschaeftTyp.RichtungEnum;

@Injectable({
  providedIn: 'root'
})
export class InterestRateCalculationService {
  getEffectiveEinstand(refiZinssatz: RefiZinssatz | undefined): number | undefined {
    if (refiZinssatz) {
      if (refiZinssatz.einstandManuell != null) {
        return refiZinssatz.einstandManuell;
      } else {
        if (refiZinssatz.einstandSwapSatz != null && refiZinssatz.einstandDiskontKorrektur != null && refiZinssatz.einstandTreasuryKurve != null) {
          return refiZinssatz.einstandSwapSatz + refiZinssatz.einstandDiskontKorrektur + refiZinssatz.einstandTreasuryKurve;
        } else return undefined;
      }
    } else return undefined;
  }

  getEffectiveMarge(refiZinssatz: RefiZinssatz | undefined): number | undefined {
    if (refiZinssatz) {
      if (refiZinssatz.margeManuell == null) {
        if (refiZinssatz.margePuffer != null && refiZinssatz.margeGt != null && refiZinssatz.margeSales != null) {
          return refiZinssatz.margePuffer + refiZinssatz.margeGt + refiZinssatz.margeSales;
        } else {
          return undefined; // Should not happen if all values are defined
        }
      } else {
        return refiZinssatz.margeManuell;
      }
    } else return undefined;
  }

  getEffectiveZinssatz(refiZinssatz: RefiZinssatz | undefined) {
    const effectiveEinstand = this.getEffectiveEinstand(refiZinssatz);
    const effectiveMarge = this.getEffectiveMarge(refiZinssatz);

    if (effectiveEinstand !== undefined && effectiveMarge !== undefined) {
      return effectiveEinstand + effectiveMarge;
    }

    return undefined;
  }

  getEffectiveZinssatzHg(zinssatz: Zinssatz | undefined, hgType: HandelsgeschaeftTyp | undefined): number {
    if (!zinssatz?.einstand || !hgType) {
      return 0;
    }

    if (zinssatz?.kundenMarge) {
      if (hgType.richtung === RichtungEnum.Aufnahme) {
        return zinssatz.einstand + zinssatz.kundenMarge;
      } else {
        return zinssatz.einstand - zinssatz.kundenMarge;
      }
    } else {
      return zinssatz.einstand;
    }
  }

  calcZinsbetrag(geschaeft: Handelsgeschaeft | undefined) {
    let zinsbetrag = 0;
    if (geschaeft?.interestFlows) {
      geschaeft?.interestFlows.forEach((item) => {
        if (item.interestFlow) {
          zinsbetrag += item?.interestFlow;
        }
      });
    }
    return zinsbetrag;
  }
}
